"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterSection = void 0;
var react_1 = __importStar(require("react"));
require("../../../index.css");
var link_1 = require("../../structure/link");
var FooterSection = /** @class */function (_super) {
  __extends(FooterSection, _super);
  function FooterSection() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.renderChildData = function (data) {
      var childView = [];
      data === null || data === void 0 ? void 0 : data.map(function (child) {
        childView.push(react_1.default.createElement("li", null, _this.renderLink(child.link, child.name)));
        return null;
      });
      return childView;
    };
    _this.renderFooterData = function () {
      var listView = [];
      _this.props.footerList.map(function (data) {
        listView.push(react_1.default.createElement("div", {
          className: "mt-12 md:mt-0"
        }, react_1.default.createElement("h3", {
          className: "text-sm font-semibold tracking-wider uppercase"
        }, data.title), react_1.default.createElement("ul", {
          className: "mt-4 space-y-4"
        }, _this.renderChildData(data.subList))));
        return null;
      });
      return listView;
    };
    _this.renderLink = function (nav, title) {
      return react_1.default.createElement(link_1.Link, {
        href: nav,
        linkType: _this.props.linkType,
        custom: _this.props.custom,
        className: "hover:underline"
      }, react_1.default.createElement("p", {
        className: "cursor-pointer text-base underline text-gray-500 hover:text-primary-600"
      }, title));
    };
    return _this;
  }
  FooterSection.prototype.render = function () {
    return react_1.default.createElement("footer", {
      className: "w-full bg-white border-t"
    }, react_1.default.createElement("div", {
      className: "max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8"
    }, react_1.default.createElement("div", {
      className: "xl:grid xl:grid-cols-3 xl:gap-8"
    }, react_1.default.createElement("div", {
      className: "grid grid-cols-1 md:grid-cols-3 gap-0 md:gap-8 xl:col-span-2"
    }, this.renderFooterData()), this.props.logoCloud && react_1.default.createElement("div", {
      className: "mt-12 space-y-4 xl:col-span-1 xl:mt-0"
    }, this.props.logoCloud)), react_1.default.createElement("div", {
      className: "mt-12 border-t border-gray-200 pt-8"
    }, react_1.default.createElement("p", {
      className: "text-base text-gray-400 xl:text-center"
    }, this.props.caption))));
  };
  return FooterSection;
}(react_1.Component);
exports.FooterSection = FooterSection;